import muster from '@dbk-legacy/muster';
import banner from './banner';
import documentList from './document-list';
import docsignSubscription from './docsign-subscription';
import acceptSign from './acceptsign';
import docusignaccept from './docusignaccept';

export default () => muster()
  .import(null, banner())
  .import(null, documentList())
  .import(null, docsignSubscription())
  .import(null, acceptSign())
  .import(null, docusignaccept());